<template>
  <button-common :action="apply" :disabled='disabled'>
    {{ buttonTitle }}
  </button-common>
</template>

<script>
import {
  mapState,
  mapGetters
} from 'vuex'
import ButtonCommon from '@/components/Button'
import MixinLocale from '@/components/MixinLocale'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    ButtonCommon
  },

  computed: {
    ...mapState('event', {
      event: 'selected'
    }),

    ...mapState('entry', [
      'entry'
    ]),

    ...mapGetters('event', [
      'hasFinished'
    ]),

    buttonTitle: function () {
      if (this.hasFinished(this.event)) {
        return this.$l.eventEnded
      }

      if (this.entry) {
        return this.$l.eventApplied
      }
      return this.$l.eventEntry
    },

    disabled: function () {
      if (this.hasFinished(this.event)) {
        return true
      }

      if (this.entry) {
        return true
      }

      return false
    }
  },

  methods: {
    apply: function () {
      this.$store.dispatch('entry/saveEntry')
      window.alert('イベントの参加申請を行いました。')
      this.$router.go(-1)
    }
  }
}
</script>
